import { C } from "./theme";

// "+ Add a task" at the foot of the tasks under a goal, a Key Date, a dream or a fear, and "+ Add a habit" (`text`) under
// a goal's habits. `style` places it in its list;
// `label` names what it adds to where a page has many ("Add a task for Sail the Greek islands").
export function AddItemButton({ onClick, label, style, text = "+ Add a task" }) {
  return (
    <button onClick={onClick} aria-label={label}
      style={{ minHeight: 44, padding: 0, background: "none", border: "none", textAlign: "left", fontSize: 15, fontWeight: 700, color: C.textGreen, cursor: "pointer", fontFamily: "inherit", ...style }}>
      {text}
    </button>
  );
}
